import getters from "./userGetters";
import actions from "./userActions";
import mutations from "./userMutations";

const state = {
    user: null,
    bpi: null,
    bpiId: null,
    bpiOutPut: null,
    currentStep: "profils_des_investisseurs",
    bpiVersion: "Version Détaillée"
};

export default {
    state,
    getters,
    actions,
    mutations
};
